// extracted by mini-css-extract-plugin
module.exports = {"mainCont":"style_mainCont__1Mg3t","open":"style_open__dR4kK","head":"style_head__24ilx","title":"style_title__qwFUp","descText":"style_descText__3gtzS"};